/*global jQuery, shop */
(function($) {

  'use strict';

  

  const $quantity = $('#quantity');
  const $price = $('#price');
  let quantity = 1;

  //console.log($('#price'));

  const formatPrice = (price) => price.toFixed(2);
  const updatePrice = () => {
    let price = 0;
    $('.product:not(.disabled)').each(function() {
      console.log($(this).data('price'))
      price += parseFloat($(this).data('price'));
    });
    price = price * quantity;
    $price.html(formatPrice(price));
  };

  const increment = () => {
    quantity = quantity + 1;
    $quantity.html(quantity);
    updatePrice();
    return false;
  };
  const decrement = () => {
    quantity = Math.max(quantity - 1, 1);
    $quantity.html(quantity);
    updatePrice();
    return false;
  };
  const selectPriceList = function() {
    const price = $(this).data('price');
    const priceList = $(this).val();
    const $product = $(this).closest('.product');

    console.log(price);

    $product.data('price', price);
    $product.data('priceList', priceList);
    updatePrice();
  };

  const updateMH = function() {
    console.log('matchHeight')
    $('.mh').matchHeight();
  }

  const selectExtra = function() {
    if ($(this).is(':checked')) {
      $(this).closest('.product').removeClass('disabled');
    } else {
      $(this).closest('.product').addClass('disabled');
    }
    updateMH()
    updatePrice();
  };

  const getProducts = () => {
    const products = [];
    $('.product:not(.disabled)').each(function() {

      var opt = $($(this).data('option')).val();
      var info = $($(this).data('addinfo')).val();
      products.push({
        product: $(this).data('product'),
        option: opt,
        info:info,
        quantity,
        priceList: $(this).data('priceList')
      });
    });
    return products;
  };

  const addToCart = function() {
    console.log('addToCart');
    const products = getProducts();
    const language = shop.language;
    console.log(products);
    

    shop.addToCartModal(products, language);
    //add_to_cart value, currency, items
    gtag('event', 'add_to_cart', {
      'currency': 'EUR',
      'items': $(this).data('nome'),
      'value': $(this).data('price')
    });
    return false;
  };

  const buy = function() {
    const products = getProducts();
    const language = shop.language;
    shop.addToCart(products, language).done((result) => {
      if (result.error) {
        shop.modalError(result.errorMessage);
        return;
      }
      setTimeout(shop.goToCart, 100);
    })
    .fail(shop.modalError);
    return false;
  };

  updatePrice();


  $('.triggerAddToCart').on('click', function(){$('#addToCart').trigger('click')});
  $('#addToCart').on('click', addToCart);
  $('#buy').on('click', buy);
  $('#quantityMinus').on('click', decrement);
  $('#quantityPlus').on('click', increment);
  $('.price-list-select').on('change', selectPriceList);
  $('.extra-select').on('change', selectExtra);

}(jQuery));
